import { useMemo } from 'react';
import {
  GetAuditEntriesByDraftReportQuery,
  useGetAuditEntriesByDraftReportQuery,
} from 'src/graphql';
import { AuditActions, AuditEntry } from 'src/types';

const ACTIONS_TO_DISPLAY = new Set(Object.keys(AuditActions));

function mapToAuditEntry(
  entry: NonNullable<
    GetAuditEntriesByDraftReportQuery['auditEntriesByDraftReport']
  >[number],
): AuditEntry {
  return {
    id: String(entry.id),
    user: {
      id: entry.User ? String(entry.User.id) : '',
      name: entry.User?.name ?? entry.User?.displayName ?? '',
    },
    organisation: String(entry.organisation),
    action: entry.action ?? '',
    completed: entry.completed ?? false,
    createdAt: entry.createdAt ?? '',
    updatedAt: entry.updatedAt ?? '',
    data: (entry.data as AuditEntry['data']) ?? {},
  };
}

export function useDraftReportAuditLog(reportId: string) {
  const { data, isLoading, error } = useGetAuditEntriesByDraftReportQuery(
    { report: reportId },
    { enabled: Boolean(reportId) && reportId !== 'new' },
  );

  const auditLog = useMemo(() => {
    const entries = data?.auditEntriesByDraftReport ?? [];
    return entries
      .filter((entry) => entry.action && ACTIONS_TO_DISPLAY.has(entry.action))
      .map(mapToAuditEntry);
  }, [data?.auditEntriesByDraftReport]);

  return { auditLog, isLoading, error };
}
